"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 1;\n  transition: opacity 0.25s linear;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  background: ", ";\n  padding: ", ";\n  &.loaded {\n    pointer-events: none;\n    opacity: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressOverlay = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

function ProgressOverlay(_ref) {
  var current = _ref.current,
      total = _ref.total;
  var loaded = current >= total || !total;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      visible = _react_1$default$useS2[0],
      setVisible = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    if (!loaded) {
      var handle = setTimeout(function () {
        setVisible(true);
      }, 250);
      return clearTimeout(handle);
    } else {
      setVisible(false);
    }
  }, [loaded]);
  var theme = react_1.default.useContext(styledTypes_1.ThemeContext);
  return react_1.default.createElement(Container, {
    className: visible ? '' : 'loaded'
  }, react_1.default.createElement(Typography_1.Body, {
    color: '@text-color-secondary'
  }, "Loaded ", current, " / ", total), react_1.default.createElement(antd_1.Progress, {
    showInfo: false,
    strokeColor: theme['@text-color-secondary'],
    percent: total ? current / total * 100 : 0,
    style: {
      width: 400
    }
  }));
}

exports.ProgressOverlay = ProgressOverlay;
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@white'];
}, function (props) {
  return props.theme['@padding-lg'];
});